import { Currency } from './types';

export const currencyNameMap: Record<Currency, string> = {
  ADA: 'Cardano',
  ALGO: 'Algorand',
  BCH: 'Bitcoin Cash',
  BTC: 'Bitcoin',
  DOGE: 'Dogecoin',
  DOT: 'Polkadot',
  ETH: 'Ethereum',
  LINK: 'Chainlink',
  LTC: 'Litecoin',
  SOL: 'Solana',
  USDT: 'Tether',
  USDC: 'USDC',
  XLM: 'Stellar',
  XRP: 'Ripple',
  EURQ: 'Euro',

  EUR: 'Euro',
  NOK: 'NOK',
  SEK: 'SEK',
  USD: 'Dollar',
};

export const getCurrencyName = (currency: Currency): string =>
  currencyNameMap[currency];
